export const careerTrainingChecklistItems = [
  {
    key: 'secCareerDiplomaNote',
    label:
      '*If a HS diploma/GED is required prior to the application process, steps will be discussed/planned for implementation after the diploma/GED is obtained.',
    confirmKey: 'confirmSecCareerDiplomaNote',
    points: 0,
    due: '',
    minVersion: 2,
    maxVersion: 99,
    type: 'instruction',
  },
  {
    key: 'secCareerExploreOptions',
    label: 'Explore and visit Career Training options that best fit your areas of interest, as well as your strengths.',
    confirmKey: 'confirmSecCareerExploreOptions',
    points: 3,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerStartDates',
    label: 'Research the start dates that the programs offer – how do these start dates align with graduation/depature dates?',
    confirmKey: 'confirmSecCareerStartDates',
    points: 3,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerSubmitApps',
    label: 'Submit 1 - 2 applications to the programs that you are most interested in and that are the best fit for you.',
    confirmKey: 'confirmSecCareerSubmitApps',
    points: 3,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerFinancialCost',
    label:
      'Look into the financial cost of the training programs that you are interested in.  Are there opportunities to apply for scholarships or other forms of financial assistance?  Write down the options that are offered to help pay for the training.',
    confirmKey: 'confirmSecCareerFinancialCost',
    points: 3,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerSubmitDeposit',
    label:
      'Submit any deposits necessary to hold/secure your application and ensure your start date is held for you. Maintain a copy of your deposit',
    confirmKey: 'confirmSecCareerSubmitDeposit',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerFafsaAccept',
    label: 'Does the training program accept grants/loans offered by completing the FASFA?   Yes  No\nIf yes:   Complete the steps below:',
    confirmKey: 'confirmSecCareerFafsaAccept',
    points: 1,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
    type: 'group-head',
    children: ['secCareerFafsaAccount', 'secCareerFafsaComplete', 'secCareerFafsaPrintSai'],
  },
  {
    key: 'secCareerFafsaAccount',
    label: 'a) Create a Federal Student Aid Account (one for you and one for a parent, if applicable).',
    confirmKey: 'confirmSecCareerFafsaAccount',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
    type: 'group-member',
    parent: 'secCareerFafsaAccept',
  },
  {
    key: 'secCareerFafsaComplete',
    label: 'b) Complete the FASFA at studentaid.gov',
    confirmKey: 'confirmSecCareerFafsaComplete',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
    type: 'group-member',
    parent: 'secCareerFafsaAccept',
  },
  {
    key: 'secCareerFafsaPrintSai',
    label: 'c) Print your received Student Aid Index(SAI).',
    confirmKey: 'confirmSecCareerFafsaPrintSai',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
    type: 'group-member',
    parent: 'secCareerFafsaAccept',
  },
  {
    key: 'secCareerAcceptedInfo',
    label:
      'Once accepted, ask for any necessary information (example: student ID/password) to log into an account for further information. Store any necessary/private information in your accordion file.',
    confirmKey: 'confirmSecCareerAcceptedInfo',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerHousingOptions',
    label:
      'Where will you live while you are enrolled in this training program?  Explore Housing opportunities and list two options that are close to the training program and are realistic for your situation.',
    confirmKey: 'confirmSecCareerHousingOptions',
    points: 3,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerHousingApps',
    label: 'Complete applications for housing or discuss living arrangements with family',
    confirmKey: 'confirmSecCareerHousingApps',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerTransportation',
    label: 'Identify 2 affordable options for transportation.',
    confirmKey: 'confirmSecCareerTransportation',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerPartTimeJob',
    label:
      'Will you need a part time job while attending this training program to pay for your living expenses?  If “yes” then find and apply for at least 3 part time jobs that fit the schedule of the training program and are near the location of where you will be living.',
    confirmKey: 'confirmSecCareerPartTimeJob',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerEquipment',
    label:
      'Look at the required equipment necessary prior to starting the training program.  Make a list of any tools that you will need.  Develop a plan for how you will plan to get the tools necessary.',
    confirmKey: 'confirmSecCareerEquipment',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerBudget',
    label: 'Create a budget that you will use after graduation when you start in this program.',
    confirmKey: 'confirmSecCareerBudget',
    points: 3,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'secCareerPlanStartDates',
    label: 'Identify and plan start dates for the program and job (if necessary) and a move in date for the housing you will live in.',
    confirmKey: 'confirmSecCareerPlanStartDates',
    points: 3,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
];
